import Axios from "axios";
import ActivityCard, { ClickableActivityContent, DefaultActivityContent } from "components/ActivityPanel/ActivityCard";
import { ButtonSecondary } from "components/Atoms/Button";
import React from "react";
import { downloadFile } from "utilities/apiUtils";

interface Props {
  currentFileId: string
  setCurrentFileId: (fileId: string) => void
  activity: server.dto.WordTemplateForListViewActivity
}

export const WordTemplateForListViewActivityCard = (props: Props) => {
  const [isRestoring, setIsRestoring] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const { activity } = props;
  const { action } = activity;

  const isFileUpload = ["uploadedNewFile", "created"].includes(action.value);
  const canRestore = isFileUpload && activity.fileId !== props.currentFileId;

  const onDownload = async () => {
    const params = {
      activityId: activity.activityId,
      fileName: activity.content,
    }

    const fileBlobRes = await Axios.post(
      window.CoreApi.WordTemplateForListView.DownloadFileFromActivity.absoluteUrl(),
      params,
      {
        responseType: "blob",
        withCredentials: true
      });
    downloadFile(fileBlobRes.data, activity.content);
  }

  const onRestore = async () => {
    setIsRestoring(true);
    const response = await window.CoreApi.WordTemplateForListView.RestoreFileFromActivity(activity.activityId);
    setIsRestoring(false);
    if (response.data.hasErrors) {
      setError(response.data.errors[0].message);
      return;
    }

    setError(null);
    props.setCurrentFileId(activity.fileId);
  }

  return <ActivityCard
    error={error}
    button={canRestore ? <ButtonSecondary
      loading={isRestoring}
      label={RESX.Buttons.Restore}
      onClick={onRestore}
    /> : null}
    activity={activity}
  >
    {!isFileUpload && <DefaultActivityContent activity={props.activity} />}
    {isFileUpload && <ClickableActivityContent
      value={activity.content}
      onClick={onDownload}
    />}
  </ActivityCard>
}